import { useQuery } from '@tanstack/react-query';
import { getTenantGroup } from 'Services';
import { RQ_GET_TENANT_GROUP } from 'Utils';

type Props = {
    tenantGroupId: string;
    queryEnabled?: boolean;
};

const useGetTenantGroup = ({ tenantGroupId, queryEnabled }: Props) => {
    return useQuery([RQ_GET_TENANT_GROUP, tenantGroupId], () => getTenantGroup(tenantGroupId), {
        enabled: queryEnabled !== false
    });
};

export default useGetTenantGroup;
